export const PERMISSION = {
  FULL_ROLE: 'full_role',
  OPERATOR: 'operator',
  VIEWER: 'viewer'
}
